
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.personId"
          v-bind="getObject('personId')"
          label="Vendedor"
          :items="extraData.accountContext.allMyEmployees"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.customerId"
          v-bind="getObject('customerId')"
          label="Cliente"
          :items="myFilteredCustomers"
          item-value="id"
          item-text="name"
          @input="clientSelected"
          autocomplete="off"
          :disabled="readOnly"
        >
        <template v-slot:append-outer>
            <PersonNew
              :inlineAddButton="true"
              :isCustomer="true"
              :sellerId="entry.personId"
              @entry-created="personCreated"
              modelNameSingular="Pessoa"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.destinyAddressId"
          v-bind="getObject('destinyAddressId')"
          label="Endereço de destino"
          :items="clientAddresses"
          item-value="id"
          item-text="fullAddressWithCityState"
          no-filter
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <DateTimeField
          :inputData.sync="entry.predictedStartTime"
          v-bind="getObject('predictedStartTime')"
          label="Data e Hora de Inicio programada"
          :hasTodayDate="false"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <DateTimeField
          :inputData.sync="entry.predictedEndTime"
          v-bind="getObject('predictedEndTime')"
          label="Data e Hora de Fim programada"
          :hasTodayDate="false"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <!-- <v-col cols="12">
        <v-autocomplete
          v-model="entry.status"
          v-bind="getObject('status')"
          label="Status"
          :items="extraData.accountContext.agendaStatuses"
          item-value="id"
          item-text="name"
          no-filter
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col> -->

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.priorityType"
          v-bind="getObject('priorityType')"
          label="Prioridade"
          :items="extraData.accountContext.agendaPriorityTypes"
          item-value="id"
          item-text="name"
          no-filter
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.contact"
          v-bind="getObject('contact')"
          label="Forma de contato"
          :items="extraData.accountContext.agendaContacts"
          item-value="id"
          item-text="name"
          no-filter
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-textarea
          v-bind="getObject('description')"
          v-model="entry.description"
          label="Objetivo do contato"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-textarea
          v-bind="getObject('afterDescription')"
          v-model="entry.afterDescription"
          label="Descrição pós visita"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-textarea
          v-bind="getObject('feedback')"
          v-model="entry.feedback"
          label="Motivo"
          outlined
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
// import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue";
import DateTimeField from "@shared_components/date_time_field.vue";
// import NewItemSelect from " /new_item_select.vue"
import PersonNew from "@models/people/new.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
      clientAddresses: [],
      clientAddressesLoading: false,
      myFilteredCustomers: [],
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateTimeField: DateTimeField,
    PersonNew: PersonNew,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    // console.log("data", this.entry.predictedStartTime);
    // console.log("data", this.entry.predictedEndTime);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if(this.extraData.accountContext.allMyEmployees && this.extraData.accountContext.allMyEmployees.length == 1){
      this.entry.personId = this.extraData.accountContext.allMyEmployees[0].id
    }
    if(this.entry.personId){
      this.myFilteredCustomers = this.extraData.accountContext.allMyCustomers.filter(value=> value.sellerId == this.entry.personId);
    }

    if(this.extraData.accountContext.allMyCustomers && this.extraData.accountContext.allMyCustomers.length == 1){
      this.entry.customerId = this.extraData.accountContext.allMyCustomers[0].id;
      // console.log("setou aqui");
      // this.getClientAddresses();
    }

    if(this.entry.customerId){
      this.getClientAddresses();
    }

    
  },
  mounted() {
    // console.log("form", this.$refs);
    // console.log(this.$refs.item);
    // this.entry.predictedStartTime = null;
    // this.entry.predictedEndTime = null;
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
    "entry.personId": function(newSearch, oldSearch){
      var employee = this.extraData.accountContext.allMyEmployees;
      var ids = employee.map(obj=> obj.id);
      console.log(employee, ids);
      var user = employee.filter(value=> value.id == newSearch)[0];
      if (user.isSeller){
        if (user.isSupervisor ){
          console.log("sup", this.extraData.accountContext.allMyCustomers);
          this.myFilteredCustomers = this.extraData.accountContext.allMyCustomers;//.filter(value=> ids.includes(value.sellerId));
        }else{
          this.myFilteredCustomers = this.extraData.accountContext.allMyCustomers.filter(value=> value.sellerId == newSearch);
        }
      }else{
        this.myFilteredCustomers = this.extraData.accountContext.allMyCustomers;//.filter(value=> ids.includes(value.sellerId));
      }
    }
    // "entry.clientId": function(newValue, oldValue){
    //   console.log("changed");
    // },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    clientSelected: function(){
      // console.log("selected");
      this.getClientAddresses();
    },
    getPurchaseItems: function() {
      this.purchaseItemsListLoading = true;
      this.$appolo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsForPurchase;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    getClientAddresses: function() {
      this.clientAddressesLoading = true;
      this.$apollo
        .query({
          query: CLIENT_ADDRESSES_QUERY,
          variables: {
            id: this.entry.customerId,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("client addresses", response.data.accountContext);
          this.clientAddresses = response.data.accountContext.allClientAddresses;
          if(this.clientAddresses && this.clientAddresses.length == 1){
            this.entry.destinyAddressId = this.clientAddresses[0].id;
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.clientAddressesLoading = false));
    },
    personCreated: function(person) {
      //testar pra ver se o tipo é supplier
      if (person.isCustomer) {
        this.myFilteredCustomers.unshift(person);
        this.entry.customerId = person.id;
        this.entry.customer = person;
        // console.log("person", person);
        this.getClientAddresses();
      } else {
        this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Cliente, por isso não irá aparecer na lista de pessoas!");
      }
    },
    formatDurationText: function() {
      this.entry.durationInHours = this.entry.durationInHours ? this.entry.durationInHours : 0;
      this.entry.durationInMinutes = this.entry.durationInMinutes ? this.entry.durationInMinutes : 0;
      
      this.entry.durationText = this.entry.durationInHours + "h"
      
      if (this.entry.durationInMinutes < 10) {
        this.entry.durationText += "0";
      }
      this.entry.durationText += this.entry.durationInMinutes + "min";
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    cultureCreated: function(culture) {
      this.extraData.adminContext.allCultures.unshift(culture);
      this.entry.cultureId = culture.id;
      this.entry.culture = culture;
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsForPurchase(query: $query) {
        id
        name
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const CLIENT_ADDRESSES_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      allClientAddresses(id: $id) {
        id
        fullAddressWithCityState
      }
    }
  }
`;
</script>

<style scoped></style>


